export default "__VITE_ASSET__128251b5__"